import React from 'react';
import { Card } from '@mui/material';
import MuiDataTable from 'components/mui-data-table/mui-data-table';
import { noRowsTitle, usePermissionChecker } from 'utils/utils';
import { useGateway } from 'hooks';

export function WithdrawsDataTable({
    withdrawData,
    isHeaderDark,
    isDashboard,
}: {
    withdrawData: any;
    isHeaderDark?: boolean;
    isDashboard?: boolean;
}) {
    const { hasPermission } = usePermissionChecker();
    const active = useGateway();

    const {
        rowsData,
        columns,
        isLoadingData,
        isSuccess,
        refetch,
        paginateInfo,
        search,
        setPage,
    } = withdrawData;

    if (!active) return <></>;

    const isPermissionTrue: boolean = hasPermission('gateway-withdraw-detail');

    return (
        <Card variant="outlined">
            <MuiDataTable
                rows={rowsData}
                columns={columns}
                isLoading={isLoadingData}
                isSuccess={isDashboard ?? isSuccess}
                onRefetch={active?.status === 'activated' ? refetch : undefined}
                paginateInfo={paginateInfo}
                setPage={setPage}
                onClickFunction={
                    // isPermissionTrue ?
                    (params) =>
                        window.open(`/${active.website}/withdraw/${params.id}`)
                    // : undefined
                }
                noRowsMessage={noRowsTitle('تسویه حسابی', search)}
                headerStyle={isHeaderDark ? 'dark' : 'light'}
            />
        </Card>
    );
}
